import { Serializer } from "../resource/serializer.interface";
import { AIReportResponse } from "./ai-report-response.model";

export class AIReportResponseSerializer implements Serializer {
  /**
   * If necessary, more significant transforms could be done here
   * @param json
   */
    fromJson(json: any): AIReportResponse {
        const aiResponse = new AIReportResponse();
        aiResponse.id = json.id;
        aiResponse.data = json.data;
        aiResponse.chart = json.chart;
    
        return aiResponse;
  }

  /**
   * For now this will do, we could generalize this in Serializer if we wanted
   * */
    toJson(aiResponse: AIReportResponse): any {
    return {
        id: aiResponse.id,
        data: aiResponse.data,
        chart: aiResponse.chart
    };
  }
}
